// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"08a827ea","311":"a3570235","580":"bf26bc2e","887":"c24f6054","895":"98064237","904":"359abff3","986":"87b596ba"}[chunkId] + ".chunk.css";
};